import moment from "moment";
import Vue from "vue";
import { router } from "@/router";
import RefundService from "@/services/RefundService";
import _ from "lodash";
import store from "@/store";

function initialState() {
  return {
    dropDownObject: {
      fromDate: new Date(),
      endDate: new Date(),
      cinema_name: null,
      cinema_id: null,
      filterValue: ''
    },
    btenable: false,
    TransactionRefunds: [],
    swapTextColor: null
  };
}

const state = initialState();

const mutations = {
  SET_DROP_DOWN_VALUES: (state, payload) => {
    switch (payload.name) {
      case "isCinema":
        state.dropDownObject.cinema_id = payload["selectedItem"]
          ? payload.selectedItem.cine_id
          : null;
        state.dropDownObject.cinema_name = payload["selectedItem"]
          ? payload.selectedItem.cine_name
          : null;
        break;
      case "fromDate":
        state.dropDownObject.filterValue = ''
        state.dropDownObject.fromDate = payload["event"]
          ? payload["event"]
          : null;
        break;
      case "endDate":
        state.dropDownObject.filterValue = ''
        state.dropDownObject.endDate = payload["event"]
          ? payload["event"]
          : null;
        break;
      case "filterValue":
        state.dropDownObject.fromDate = null
        state.dropDownObject.endDate = null
        state.dropDownObject.filterValue = payload["event"]
          ? payload["event"]
          : null;
        break;
      default:
        console.log(
          "Transaction Refunds Report :( Sorry, we are enable to set value."
        );
    }
  },
  CLEAR_DATE: (state, payload) => {
    switch (payload.name) {
      case "fromDate":
        state.dropDownObject.fromDate = null;
        break;
      case "endDate":
        state.dropDownObject.endDate = null;
        break;
      default:
        console.log("Unable to clear Date");
    }
  },
  UNSELECT_CINEMA: state => {
    (state.dropDownObject.cinema_id = null),
      (state.dropDownObject.cinema_name = null);
  },
  SET_TRANSACTION_REFUND_DATA: (state, payload) => {
    state.TransactionRefunds = payload || [];
  },
  CHANGE_BUTTON_VALUE: (state, payload) => {
    state.btenable = payload;
    store.dispatch("onFetchTransactionRefunds");
  },
  False_BUtton_Value: (state, payload) => {
    state.btenable = payload;
  },
  SET_SWAP_COLOR: (state, payload) => {
    state.swapTextColor = payload;
  }
};

const actions = {
  clearDate: async ({ dispatch, commit, state }, payload) => {
    await commit("CLEAR_DATE", payload);
  },
  onTransactionRefundsDropDownHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  ButtonValue: async ({ dispatch, commit, state }, payload) => {
    commit("CHANGE_BUTTON_VALUE", payload);
  },
  onFetchTransactionRefunds: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_TRANSACTION_REFUND_DATA", []);
    let loader = Vue.$loading.show();
    state.dropDownObject["fromDate"] = state.dropDownObject["fromDate"] ? moment(state.dropDownObject["fromDate"]).format("YYYY-MM-DD") : ''
    state.dropDownObject["endDate"] = state.dropDownObject["endDate"] ? moment(state.dropDownObject["endDate"]).format("YYYY-MM-DD") : ''

    await RefundService.GetTransactionRefunds(state.dropDownObject)
      .then(async response => {
        commit("False_BUtton_Value", false);
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_TRANSACTION_REFUND_DATA", data.Records);
          if (
            data.hasOwnProperty("SwapRefundColor") &&
            data.SwapRefundColor.length > 0
          ) {
            commit("SET_SWAP_COLOR", data.SwapRefundColor[0].color);
          }
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on Transaction refund", error);
      });
  }
};

const getters = {
  getTransactionRefundSelectedCinema: state => state.dropDownObject.cinema_name,
  getTransactionRefundFromDate: state => state.dropDownObject.fromDate,
  getTransactionRefundEndDate: state => state.dropDownObject.endDate,
  getTransactionRefundFilterValue: state => state.dropDownObject.filterValue,
  getTransactionRefundstData: state => state.TransactionRefunds,
  enablebutton: state => state.btenable,
  swaptextcolor: state => state.swapTextColor
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/TransactionRefundStore.js